import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { interpolateBrandVariables } from '#app/utils/pz/brand/interpolation'
import { deepMerge } from '#app/utils/pz/object.ts'
import en from '../../locales/en/index'
import es from '../../locales/es/index'

/**
 * Get interpolated translations.
 * This is called lazily to ensure window.ENV is available.
 */
function getInterpolatedResources() {
	const overrides = (typeof window !== 'undefined' &&
		(window as any).ENV?.I18N_OVERRIDES) || { en: {}, es: {} }
	const enMerged = deepMerge(en as any, overrides.en || {})
	const esMerged = deepMerge(es as any, overrides.es || {})

	// Interpolate brand variables ({{brandName}}, {{brandDomain}}, etc.)
	// At this point window.ENV.BRAND should be available
	const enInterpolated = interpolateBrandVariables(enMerged, { language: 'en' })
	const esInterpolated = interpolateBrandVariables(esMerged, { language: 'es' })

	return {
		en: { translation: enInterpolated },
		es: { translation: esInterpolated },
	}
}

// Initialize i18n with lazy resource loading
// Resources are loaded when init() is called, after window.ENV is set
export const i18nClientReady = i18n.use(initReactI18next).init({
	// Ensure the initial language matches SSR by reading <html lang="...">
	lng:
		typeof document !== 'undefined'
			? document.documentElement.lang || undefined
			: undefined,
	supportedLngs: (typeof window !== 'undefined' &&
		(window as any).ENV?.I18N_SUPPORTED) || ['en', 'es'],
	fallbackLng:
		(typeof window !== 'undefined' && (window as any).ENV?.I18N_FALLBACK) ||
		'en',
	defaultNS: 'translation',
	initImmediate: false,
	returnNull: false,
	react: {
		useSuspense: false,
	},
	resources: getInterpolatedResources(),
})

export default i18n
